<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Attendance List</h2>
        </div>
        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Staff Name</th>  
                                    <th class="bg-[#B2E8D9]">Presenty</th>
                                 
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item, index) in staffList" :key="item.id">
                                    <td>
                                        <input type="text" :value="item.firstname" readonly>
                                        <input type="hidden" v-model="attendance[index].staff_id" :value="item.id">
                                    </td>
                                    <td>
                                        <input type="checkbox" v-model="attendance[index].presenty" :value="1" :true-value="1" :false-value="0">
                                    </td>
                                </tr>
                                                               
                            </tbody>
                        </table>
                        <button @click="save_attendance" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->
       <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->


    


</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'AddProduct',
components: {
 
} ,
mounted(){
 this.getBasics();
},
data() {
 return {
     staffList:[],
     attendance: [],
    // attendance: { 
    //     staff_id: '', 
    //     presenty:false,
    //         },
 }
 }, 
methods:{
    save_attendance() {
    // Loop through the attendance data and update the presenty field based on checkbox state
    const attendanceToSave = this.attendance.map(attendance => {
        // If the attendance is checked, mark it as present (1), otherwise mark as absent (0)
        if (attendance.presenty == 1) {
            attendance.presenty = 1;  // Present
        } else {
            attendance.presenty = 0;  // Absent
        }
        return attendance; // Return the modified attendance object
    });

    // Send all attendance records (both present and absent) to the backend
    axios.post('saveAttendance', { attendance: attendanceToSave })
        .then(response => {
            alert(response.data.msg);
            // this.getBasics();
        })
        .catch(error => {
            console.error('Error saving attendance:', error);
            alert('An error occurred while saving attendance.');
        });
}
,
 async getBasics() {
       var self=this;
         axios.post('getStaffAttendanceList').then(function (response) {
                  self.staffList=response.data.staff;
                  self.attendance = self.staffList.map(staff => ({
                    staff_id: staff.id,      
                    presenty: staff.presenty || 0             
                }));
                })
                .then(()=>{ 
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
              
                    });;
  }, 
  
  

            
}
}
</script>
<style scoped>
    
    </style>